import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { sanitizeFloat } from 'helper/sanitize';
import { VALIDATE_IS_NOT_ALLOWED } from 'helper/validator';

const settings = {
	minLength: 1,
	maxLength: 3,
};

export const codes = {
	empty: 1,
	invalidFormat: 2,
	exceedsOverall: 3,
	withinWarning: 4,
};

const validRegex = /([0-9]+([0-9]+)?)/g;

export default function numbersValidatorFactory(inputValue: string): Promise<ValidationError | undefined> {
	return new Promise((resolve: Function, reject: Function) => {
		const toVerify: string = inputValue.toString();

		if (toVerify === '') {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(
					'react.impulsCoach.components.cardDetail.workout.custom.validationDuration.invalidFormat'
				),
			});
			return;
		}

		if (parseInt(inputValue, 10) <= 0) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(
					'react.impulsCoach.components.cardDetail.workout.custom.validationDuration.invalidFormat'
				),
			});
			return;
		}

		if (!inputValue.match(validRegex)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(
					'react.impulsCoach.components.cardDetail.workout.custom.validationDuration.invalidFormat'
				),
			});
			return;
		}

		if (toVerify.length < settings.minLength || toVerify.length > settings.maxLength) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(
					'react.impulsCoach.components.cardDetail.workout.custom.validationDuration.invalidLength'
				),
			});
			return;
		}

		resolve();
	});
}

export const sanitize = (value: string): string => {
	return sanitizeFloat(value, 3);
};
